export const blockIconsNotificationPriorityHigh = (
	<span className='material-symbols-outlined'>priority_high</span>
);
